import React from 'react';
import {formulaGuides} from '../lib/formulaGuides';
import BiotypeExplorer from './BiotypeExplorer';
import './formula-library.css';

function FormulaCard({guide}) {
  return (
    <details className="formula-guide">
      <summary><span>{guide.name}</span><small>{guide.author} · {guide.year}</small></summary>
      <div className="formula-guide-content">
        <p className="equation">{guide.equation}</p>
        <dl>
          <dt>População de desenvolvimento</dt><dd>{guide.population}</dd>
          <dt>Lógica em linguagem simples</dt><dd>{guide.logic}</dd>
          <dt>Quando usar</dt><dd>{guide.when}</dd>
          <dt>Como usar, passo a passo</dt><dd>{guide.steps}</dd>
          <dt>Aplicações típicas</dt><dd>{guide.applications}</dd>
          <dt>Limitações</dt><dd>{guide.limitations}</dd>
        </dl>
        <p className="formula-universal-note">Não existe fórmula universalmente melhor. Protocolos institucionais ou estudos podem exigir uma equação específica.</p>
      </div>
    </details>
  );
}

function ChoosingGuide() {
  return (
    <section className="choosing-guide">
      <h2>Como escolher uma fórmula de superfície corporal?</h2>
      <p>A primeira regra é conferir se a publicação, o serviço ou o protocolo que motivou o cálculo pede uma equação específica. As fórmulas desta página não são simples formatos intercambiáveis: foram propostas em anos diferentes, com métodos e populações de referência distintos. Uma diferença entre resultados é esperada e não identifica, por si só, qual deles representa melhor uma pessoa.</p>
      <p>Quando a altura e o peso estão disponíveis e não há um método obrigatório, Mosteller costuma ser fácil de calcular e conferir; por isso, é o resultado inicial desta ferramenta. Isso não torna Mosteller universalmente superior. Du Bois e Du Bois é uma referência histórica; Haycock é frequentemente considerada em comparações pediátricas e neonatais; outras equações podem aparecer em pesquisas ou contextos populacionais particulares. A idade, a população, o objetivo e a metodologia do estudo importam tanto quanto a simplicidade da conta.</p>
      <p>Se a altura não foi medida, Livingston e Lee é a única opção desta biblioteca que usa apenas peso. Essa conveniência tem um custo: duas pessoas com o mesmo peso, mas alturas diferentes, recebem a mesma estimativa por essa equação. Boyd exige que o peso seja convertido para gramas na fórmula, enquanto as demais equações indicam peso em quilogramas. Antes de comparar números, confirme as unidades, os dados inseridos e a variante escolhida.</p>
      <p>Para oncologia, pediatria, neonatologia, hemodinâmica, índice cardíaco ou normalização de função renal, siga a referência clínica correspondente. Um resultado de superfície corporal não fornece uma dose, não calcula por si só a taxa de filtração glomerular e não substitui a avaliação de exames ou do paciente. Em particular, a TFG indexada a 1,73 m² e uma estimativa de superfície corporal são conceitos relacionados à área, mas não são a mesma medida.</p>
      <p>Use o seletor para escolher qual estimativa destacar e ative “Comparar todas” para observar os valores e suas diferenças percentuais em relação a Mosteller. Um aviso acima de 5% sinaliza divergência entre estimativas, não um erro confirmado. A decisão final sobre o método pertence ao protocolo e ao profissional responsável.</p>
    </section>
  );
}

export default function FormulaLibrary() {
  return (
    <section className="panel formula-library" id="biblioteca" aria-labelledby="library-title">
      <div className="section-heading">
        <p className="eyebrow">Biblioteca de fórmulas</p>
        <h2 id="library-title">Quais fórmulas estão disponíveis?</h2>
        <p>Escolha no cálculo qual equação destacar. Abra cada linha para consultar a fórmula, a população de referência, as aplicações e as limitações. P é peso em kg; A é altura em cm; resultado em m².</p>
      </div>
      <ChoosingGuide />
      <BiotypeExplorer />
      <div className="formula-guide-list">
        {formulaGuides.map(guide => <FormulaCard key={guide.name} guide={guide} />)}
      </div>
    </section>
  );
}
